class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    //this.toggleAddButton(true, '', false);

    if (!this.currentVariant) {
      //this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.dispatchVariantChange();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);

     // when size dropdown selector change, update size radios selected value
     const thisOptions = this.options;

     // get all size radio buttons
    const sizeRadios = document.querySelectorAll('input[type="radio"][name="size"]');

    for (var i = 0; i < sizeRadios.length; ++i) {

      let sizeEl = sizeRadios[i];
      let size = sizeRadios[i].value;

      // check if size exist in current variant options
      let sizeExists = Object.values(thisOptions).includes(size);

      // trigger click
      if(sizeExists) {
        sizeEl.click();
        break;
      }
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent(
        'variant-change',
        {
          bubbles: true,
          variant: this.currentVariant,
          detail: {
            variant: this.currentVariant
          }
        }
      )
    );
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        // update price
        const idPrice = `price-${this.dataset.section}`;
        const destinationPrice = document.getElementById(idPrice);
        const sourcePrice = html.getElementById(idPrice);
        if (sourcePrice && destinationPrice) destinationPrice.innerHTML = sourcePrice.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        if (this.currentVariant) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        }

        // Update the inventory quantity hidden input
        const inventoryQtyDestination = document.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
        const inventoryQtySource = html.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
        inventoryQtyDestination.value = inventoryQtySource.value;
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {

    const addButtons = document.querySelectorAll('[name="add"]');
    const klaviyoButtons = document.querySelectorAll('[data-klaviyo-bis-trigger]');

    for (let index = 0; index < addButtons.length; index++) {

      let addButton = addButtons[index];
      let klaviyoButton = klaviyoButtons[index];

      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', true);
        addButton.classList.add('hidden');
        klaviyoButton.classList.remove('hidden');
        klaviyoButton.style.display = 'flex';
        if (text) addButton.querySelector('span').textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButton.classList.remove('hidden');
        klaviyoButton.classList.add('hidden');
        klaviyoButton.style.display = 'none';
        addButton.querySelector('span').textContent = window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    }

  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    // when radio buttons change, update size dropdown selector with selected value
    const thisOptions = this.options;
    const sizesDropdown = document.querySelector('.product-form__input--size .custom-select__list') || false;
    if (sizesDropdown) {
      const sizes = sizesDropdown.getElementsByTagName('li');
      for (var i = 0; i < sizes.length; ++i) {
        let sizeEl = sizes[i];
        let size = sizes[i].dataset.value;
        let sizeExists = Object.values(thisOptions).includes(size);

        // trigger click when we found the current selected size
        if(sizeExists) {
          sizeEl.click();
          break;
        }
      }
    }
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}

